<div class="block-{{ platform }} block">
  @if (headerText) {
    <div class="header">
      <app-text
        [textSize]="TextSizes.h1Header"
        [textType]="TextType.base"
        [text]="headerText"
      ></app-text>
      <div class="header__info-icon">
        @if (iconImg) {
          <img [src]="iconImg" alt="icon" />
        }
        <div class="info-description">
          @for (description of descriptions; track description) {
            <app-text
              [text]="description"
              [textSize]="TextSizes.h3Body"
              [textType]="TextType.base"
            ></app-text>
          }
        </div>
      </div>
    </div>
  }
  <ng-content></ng-content>
</div>
